// domain/nada — pilihan nada bel notifikasi.
//
// Nadanya DIBANGKITKAN di dalam aplikasi (WebAudio), bukan berkas suara: berkas harus ikut diunduh
// tiap membuka aplikasi di HP karyawan, dan aplikasi ini sengaja tak menyimpan cache supaya data
// uang tak pernah basi. Nada bangkitan berukuran nol byte.
//
// Bagian yang murni (daftar + validasi) ada di sini agar bisa diuji; pemutarnya di core/sound.ts.

export interface Nada {
  id: string;
  label: string;
  /** Deret nada: [frekuensi Hz, mulai detik, panjang detik]. Kosong = tak berbunyi. */
  deret: [number, number, number][];
}

/** Nada dipilih tiap pengguna. Sengaja sedikit & berbeda jelas — bukan koleksi. */
export const NADA: Nada[] = [
  { id: 'bel', label: '🔔 Bel lembut', deret: [[880, 0, 0.18], [1174, 0.10, 0.28]] },
  { id: 'denting', label: '✨ Denting', deret: [[1568, 0, 0.35]] },
  { id: 'dua', label: '📣 Dua-nada', deret: [[660, 0, 0.14], [523, 0.16, 0.22]] },
  { id: 'trilili', label: '🎵 Trilili', deret: [[784, 0, 0.09], [988, 0.10, 0.09], [1319, 0.20, 0.22]] },
  { id: 'tegas', label: '⚠️ Tegas (2×)', deret: [[440, 0, 0.12], [440, 0.20, 0.12]] },
  { id: 'mati', label: '🔇 Tanpa suara', deret: [] },
];

export const NADA_BAWAAN = 'bel';

/**
 * Pilihan tersimpan → id yang pasti ada di daftar.
 *
 * Nilainya tinggal di perangkat pengguna, jadi bisa terbawa dari versi lama, disunting tangan,
 * atau rusak. Kalau tak dikenal, kembalikan nada bawaan — BUKAN diam: pengingat kerja yang tak
 * bersuara adalah kegagalan yang paling tak disadari. 'mati' tetap dihormati karena itu pilihan sah.
 */
export function nadaValid(id: string | null | undefined): string {
  return NADA.some((n) => n.id === id) ? (id as string) : NADA_BAWAAN;
}

export const nadaOf = (id: string): Nada => NADA.find((n) => n.id === nadaValid(id))!;
